import * as React from 'react';
export default function SvgSalesforce() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 17.25c.679 0 1.31-.208 1.83-.564a2.75 2.75 0 004.111-.92 2.75 2.75 0 004.28-1.877 2.25 2.25 0 00-2.038-3.987 2.75 2.75 0 00-4.387-1.56 3.25 3.25 0 00-5.734 3.05A3.25 3.25 0 008 17.25z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}